const autoNgTemplateLoaderTemplate1 = require('./Logs/logs.html');

import { isNomadEnvironment } from '@/portainer/environments/utils';
import { ping } from '@/nomad/rest/ping';
import { NomadDashboardAngular } from './Dashboard';
import { JobsViewAngular } from './Jobs';
import { NomadEventsAngular } from './Events/Events';
import { reactModule } from './react';

function config($stateRegistryProvider) {
  'use strict';

  const nomad = {
    name: 'nomad',
    url: '/nomad',
    parent: 'endpoint',
    abstract: true,

    onEnter: /* @ngInject */ function onEnter($async, $state, endpoint, Notifications, StateManager, EndpointProvider) {
      return $async(async () => {
        if (!isNomadEnvironment(endpoint.Type)) {
          $state.go('portainer.home');
          return;
        }

        try {
          await ping(endpoint.Id);
          EndpointProvider.setEndpointID(endpoint.Id);
          await StateManager.updateEndpointState(endpoint, []);
        } catch (e) {
          Notifications.error('Unable to contact Edge agent, please ensure that the agent is properly running on the remote environment.');
          $state.go('portainer.home', {}, { reload: true });
        }
      });
    },
  };

  const dashboard = {
    name: 'nomad.dashboard',
    url: '/dashboard',
    views: {
      'content@': {
        component: 'nomadDashboard',
      },
    },
  };

  const jobs = {
    name: 'nomad.jobs',
    url: '/jobs',
    views: {
      'content@': {
        component: 'nomadJobs',
      },
    },
  };

  const events = {
    name: 'nomad.events',
    url: '/jobs/:jobID/tasks/:taskName/allocations/:allocationID/events?namespace',
    views: {
      'content@': {
        component: 'nomadEvents',
      },
    },
  };

  const logs = {
    name: 'nomad.logs',
    url: '/jobs/:jobID/tasks/:taskName/allocations/:allocationID/logs?namespace',
    views: {
      'content@': {
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'LogsController',
      },
    },
  };

  $stateRegistryProvider.register(nomad);
  $stateRegistryProvider.register(dashboard);
  $stateRegistryProvider.register(jobs);
  $stateRegistryProvider.register(events);
  $stateRegistryProvider.register(logs);
}

export const nomadModule = angular
  .module('portainer.nomad', ['portainer.app', reactModule])
  .config(['$stateRegistryProvider', config])
  .component('nomadDashboard', NomadDashboardAngular)
  .component('nomadEvents', NomadEventsAngular)
  .component('nomadJobs', JobsViewAngular).name;
